import React from 'react';
import { Link } from "react-router-dom";


class PotentialAAUserTile extends React.Component {
    render() {
        return (
            <div className="card auto-aal-tile">
                <div className="card-header">
                    <div className="row">
                        <div className="col-12">
                            <div className="card-heading">BSWQA-DFW CONNECTEDCARE</div>
                        </div>
                    </div>
                </div>

                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12 intro-text">Do you have a BSWQA-DFW ConnectedCare health insurance plan?</div>
                                <div className="col-12 intro-text">Link your plan using your member ID or other information to help us verify you.</div>
                            </div>
                        </div>                        
                    </div>
                </div>
                <div className="card-footer">
                    <div className="row">                        
                        <div className="col-12 col-md-12">
                            <Link className="card-link" to={{ pathname: "/linkedaccounts" }}>LINK MY HEALTH INSURANCE PLAN</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default PotentialAAUserTile;